import { ITriageRequestsFilters } from '~/services/api/triage/types';

export const getInitialValues = (): ITriageRequestsFilters => ({
  patientFullName: '',
  issueName: '',
  startDate: '',
  endDate: '',
});

export default {};
